export interface EbNotificationWrapper {
  message: Message;
  type: string;
  broadcastContacts: BroadcastContacts;
  broadcastSettings: BroadcastSettings;
}

export interface Message {
  title: string;
  textMessage: string;
  useCustomEmail: boolean;
  rtfContent: string;
  questionaire: Questionaire;
}

export interface Questionaire {
  answers: Answer[];
}

export interface Answer {
  name: string;
}

export interface BroadcastContacts {
  externalIds: string[];
}

export interface BroadcastSettings {
  senderEmail: string;
  duration: number;
  contactCycles: number;
  cycleInterval: string;
  deliveryMethodInterval: string;
  language: string;
  voiceMailOption: string;
  deliverPaths: DeliverPath[];
}

export interface DeliverPath {
  id: number;
  pathId: number;
  pathType: string;
}

export const PathData = [
  {
    pathId: '241901148045324',
    pathType: 'SMS',
  },
  {
    pathId: '241901148045319',
    pathType: 'PHONE',
  },
  {
    pathId: '241901148045314',
    pathType: 'PHONE',
  },
  {
    pathId: '241901148045315',
    pathType: 'SMS',
  },
  {
    pathId: '241901148045316',
    pathType: 'EMAIL',
  },
];

export const deviceDelayOptions: any[] = [
  { label: 1 },
  { label: 2 },
  { label: 3 },
  { label: 5 },
  { label: 10 },
  { label: 15 },
];

export const contactCycleDelayOptions: any[] = [
  { label: 1 },
  { label: 2 },
  { label: 5 },
  { label: 10 },
  { label: 15 },
  { label: 20 },
  { label: 25 },
  { label: 30 },
  { label: 35 },
  { label: 40 },
  { label: 45 },
  { label: 50 },
  { label: 55 },
  { label: 60 },
];

export const leaveMessageOptions: any[] = [
  { label: 'Message Only', code: 'MESSAGE_ONLY' },
  { label: 'Message with Confirmation', code: 'MESSAGE_WITH_CONFIRMATION' },
  { label: 'No Message', code: 'NO_MESSAGE' },
];

export const deviceSourceOptions: any[] = [
  {
    deviceName: 'Work Email',
    deviceCode: '241901148045316',
  },
  {
    deviceName: 'Work Mobile Voice',
    deviceCode: '241901148045319',
  },
  {
    deviceName: 'Work Mobile SMS',
    deviceCode: '241901148045324',
  },
  {
    deviceName: 'Personal Mobile Voice',
    deviceCode: '241901148045320',
  },
  {
    deviceName: 'Personal Mobile SMS',
    deviceCode: '241901148045315',
  },
];

export const userOptions: any[] = [
  {
    name: 'Responded',
    code: 'RESPONDED',
  },
  {
    name: 'Not Responded',
    code: 'NOT_RESPONDED',
  },
];
